import { getResourceAllocationTotal } from '~/modules/resourcing/hooks/useResourceAllocationTotal';
import { getResourceRequestTotal } from './withResourceRequestTotal';

export const getProjectResourcingPlanTotals = ({
  resourceRequests = [],
  resourceAllocations = [],
  excludedRequestIds = [],
  contextCurrency,
  me
}) => {
  const requestTotals = resourceRequests.map(r =>
    getResourceRequestTotal({ contextCurrency, ...r })
  );

  const allocationExcludingRequests = resourceAllocations.filter(
    allocation => !excludedRequestIds.includes(allocation.resourceRequestId)
  );

  const allocationTotals = allocationExcludingRequests.map(a =>
    getResourceAllocationTotal({
      me,
      contextCurrency,
      ...a
    })
  );

  const mergedTotals = allocationTotals.concat(requestTotals);

  const totalCost = mergedTotals.reduce((retVal, total) => {
    const { resourceRequestTotalCost, resourceAllocationCost } = total;

    const { currencyUri, currencySymbol, amount } =
      resourceRequestTotalCost || resourceAllocationCost;

    return currencyUri
      ? {
          ...retVal,
          [currencyUri]: retVal[currencyUri]
            ? {
                ...retVal[currencyUri],
                ...(resourceRequestTotalCost
                  ? {
                      requestedAmount:
                        retVal[currencyUri].requestedAmount + amount
                    }
                  : {
                      allocatedAmount:
                        retVal[currencyUri].allocatedAmount + amount
                    })
              }
            : {
                currencyUri,
                currencySymbol,
                requestedAmount: resourceRequestTotalCost ? amount : 0,
                allocatedAmount: resourceAllocationCost ? amount : 0
              }
        }
      : retVal;
  }, {});

  return {
    totalHours: {
      requestedHours: Number(
        requestTotals
          .reduce((total, v) => total + v.resourceRequestTotalHours, 0)
          .toFixed(4)
      ),
      allocatedHours: Number(
        allocationTotals
          .reduce((total, v) => total + v.resourceAllocationHours, 0)
          .toFixed(4)
      )
    },
    allocationExcludingRequests,
    totalCost: Object.keys(totalCost).map(key => totalCost[key])
  };
};
